import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import PrivateRoute from "./privat-routs/PrivateRoute";
import LoginScreen from "../pages/login/login-screen";
import ChatScreen from "../pages/chat-screen/chat-screen";
import AdminPanel from "../pages/admin-panel/admin-panel";
import { useAuthStore } from "../stores/authStore";
import { useEffect } from "react";
import { useVerifyToken } from "../hooks/useVerifyToken";

const RedirectToLogin = () => {
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const domain = urlParams.get("domain");
    const focus = urlParams.get("focus");
    const messageId = urlParams.get("message_id");
    const roleplay = urlParams.get("roleplay");
    const mode = urlParams.get("mode");

    if (domain || focus || messageId || roleplay || mode) {
      const savedParams: {
        domain?: string;
        focus?: string;
        message_id?: string;
        roleplay?: string;
        mode?: string;
      } = {};

      if (domain) savedParams.domain = domain;
      if (focus) savedParams.focus = focus;
      if (messageId) savedParams.message_id = messageId;
      if (roleplay) savedParams.roleplay = roleplay;
      if (mode) savedParams.mode = mode;

      sessionStorage.setItem(
        "pendingChallengeData",
        JSON.stringify(savedParams)
      );
    }
  }, [location.search]);

  return <Navigate to="/login" replace />;
};

const AppRouter = () => {
  const { isAuthenticated, setAuthenticated } = useAuthStore();
  const { isValid, message } = useVerifyToken();

  useEffect(() => {
    if (isValid !== null) {
      setAuthenticated(isValid);
    }
  }, [isValid, message, setAuthenticated]);

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/chat" replace /> : <LoginScreen />
          }
        />
        <Route
          path="/chat"
          element={
            <PrivateRoute>
              <ChatScreen />
            </PrivateRoute>
          }
        />

        <Route
          path="/panel-47da9a7fba"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />

        <Route path="/" element={<RedirectToLogin />} />
        <Route path="*" element={<p>404 - Page not found</p>} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
